import React from 'react';

const footerLinks = {
  Treatments: [
    'Advanced Botox Therapy',
    'Dermal Fillers',
    'Fat Removal',
    'Mesotherapy',
    'Exosomes Therapy',
    'Salmon DNA Therapy',
  ],
  'Quick Links': ['About', 'Services', 'Results', 'Testimonials', 'Contact'],
  Legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy'],
};

export default function Footer() {
  return (
    <footer className="bg-charcoal-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <span className="font-serif text-2xl font-medium">
                Dr. Noora Ibrahim
              </span>
              <span className="block text-[10px] tracking-[0.3em] uppercase text-gold-400 mt-1">
                Medical Aesthetics
              </span>
            </div>
            <p className="text-sm text-charcoal-400 leading-relaxed mb-4">
              Enhancing your natural beauty with precision, artistry, and the
              highest standard of medical care.
            </p>
            <a
              href="tel:+97150501917"
              className="inline-flex items-center gap-2 text-sm text-gold-400 hover:text-gold-300 transition-colors mb-6"
            >
              +971 5050 19175
            </a>
            <div className="flex gap-3">
              {[
                { label: 'IG', url: 'https://www.instagram.com/dr_noora_asthetics_' },
                { label: 'FB', url: '#' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-charcoal-700 flex items-center justify-center text-xs text-charcoal-400 hover:border-gold-400 hover:text-gold-400 transition-colors cursor-pointer"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-xs tracking-[0.2em] uppercase text-gold-400 font-medium mb-6">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href={`#${link.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm text-charcoal-400 hover:text-white transition-colors duration-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-charcoal-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-charcoal-500">
            &copy; {new Date().getFullYear()} Dr. Noora Ibrahim Medical
            Aesthetics. All rights reserved.
          </p>
          <p className="text-xs text-charcoal-600">
            Designed with care for{' '}
            <span className="text-gold-400">drnooraibrahim.com</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
